import * as React from "react";

export interface IH2Props {
  className?: string;
}

const H2: React.StatelessComponent<IH2Props> = ({ children, className }) => <h2 className={`h2 ${className}`}>{children}</h2>;

export default H2;
